
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menus/checkout",
      function () {
        return require("private-next-pages/menus/checkout.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menus/checkout"])
      });
    }
  